import { render, staticRenderFns } from "./DialogGalleriaCalciatori.vue?vue&type=template&id=7cd1274c&scoped=true&"
import script from "./DialogGalleriaCalciatori.vue?vue&type=script&lang=js&"
export * from "./DialogGalleriaCalciatori.vue?vue&type=script&lang=js&"
import style0 from "./DialogGalleriaCalciatori.vue?vue&type=style&index=0&id=7cd1274c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1274c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd1274c')) {
      api.createRecord('7cd1274c', component.options)
    } else {
      api.reload('7cd1274c', component.options)
    }
    module.hot.accept("./DialogGalleriaCalciatori.vue?vue&type=template&id=7cd1274c&scoped=true&", function () {
      api.rerender('7cd1274c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogGalleriaCalciatori.vue"
export default component.exports